const mutations = {
  paypalResource: (state, payload) => {
    state.paypalResource = payload
  },
  cart: (state, payload) => {
    state.cart = payload
  },
  billing: (state, payload) => {
    state.billing = payload
  },
  closeupVideoUploadProgess: (state, payload) => {
    state.closeupVideoUploadProgess = payload
  },
  updateWatchTime: (state, payload) => {
    state.closeupWatchTime = payload
  }
}

export default mutations
